import HttpService from 'services/commons/HttpService';
// import * as Sentry from '@sentry/react';
import {
  CLIENT_SECRET,
  ROLES_MANAGEMENT_BASIC,
  ROLES_NOSERVICEVALUE,
  ROLE_CANNOT_CREATE_SERVICE_ON_APPOINTMENT,
  ROLE_CANNOT_DELETE_APPOINTMENTS,
  ROLE_CANNOT_EDIT_APPOINTMENTS,
  ROLE_CAN_EDIT_PRICE_ON_APPOINTMENT_CREATION,
  ROLE_MENU_CUSTOMERS,
} from 'commons/constants';
import { ROLES_ALLOW_AGENDA_FROM_OTHERS, ROLES_ALLOW_AGENDA, ROLES_NOCUSTOMER } from 'commons/constants';

import qs from 'qs';
import { resetStore } from 'stores/appStore';

const ROLES_MANAGEMENT_BASIC_OR_CUSTOMER_MENU = [...ROLES_MANAGEMENT_BASIC, ROLE_MENU_CUSTOMERS];

const AuthService = {
  isUserLoggedIn: (user) => {
    if (!user || !user.access_token) {
      return false;
    }
    const now = new Date();
    const expiryDate = new Date(user.expiryDate);
    return now < expiryDate;
  },
  login: (userLogin) => {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic ' + CLIENT_SECRET,
      },
    };
    const formData = qs.stringify({
      username: userLogin.username,
      password: userLogin.password,
      grant_type: 'password',
    });
    return HttpService.post('/oauth/token?isWeb=true', formData, config).then((loggedInUser) => {
      // record user
      if (process.env.NODE_ENV === 'production') {
        // Sentry.setUser({ email: loggedInUser.principal.username });
      }

      // eslint-disable-next-line no-param-reassign
      // loggedInUser.roles = loggedInUser.authorities.map(o => o.authority);
      const now = new Date();
      const expiryDate = new Date(now.getTime() + (loggedInUser.expires_in * 1000 - 20));
      return {
        ...loggedInUser,
        roles: loggedInUser.principal.authorities.map((o) => o.authority),
        expiryDate: expiryDate.getTime(),
      };
    });
  },
  logout: () =>
    HttpService.post('/logout').then((resp) => {
      resetStore();
      return resp;
    }),
  getLoggedInUser: () => HttpService.get('/auth/loggedInUser'),
  updatePassword: (passwordUpdateRequest, acessToken) => {
    if (acessToken) {
      const config = {
        headers: {
          Authorization: `Bearer ${acessToken}`,
        },
      };
      return HttpService.post('/resetPassword', passwordUpdateRequest, config);
    }
    return HttpService.post('/resetPassword', passwordUpdateRequest);
  },
  sendResetPasswordCode: (email) => {
    return HttpService.post('/passwordRecovery?generateCodeLink=true', { email });
  },
  resetPassword: (code, password) => {
    return HttpService.post('/passwordRecovery/reset', { code, password });
  },
  isAuthorized: (userRoles, requiredRoles) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;
    if (requiredRoles && requiredRoles.length > 0 && (!userRoles || userRoles.length === 0)) return false;
    return requiredRoles.some((val) => userRoles.indexOf(val) !== -1);
  },
  allowAgendaFromOthers: (userRoles) => {
    if (!userRoles || userRoles.length === 0) {
      return false;
    }
    return ROLES_ALLOW_AGENDA_FROM_OTHERS.some((val) => userRoles.indexOf(val) !== -1);
  },
  allowsAgenda: (userRoles) => {
    if (!userRoles || userRoles.length === 0) {
      return false;
    }
    return ROLES_ALLOW_AGENDA.some((val) => userRoles.indexOf(val) !== -1);
  },
  checkCannotAccessCustomer: (userRoles) => {
    return userRoles != null && ROLES_NOCUSTOMER.some((val) => userRoles.includes(val));
  },
  checkCannotAccessServiceValue: (userRoles) => {
    return userRoles != null && ROLES_NOSERVICEVALUE.some((val) => userRoles.includes(val));
  },
  checkCannotEditAppointments: (userRoles) => {
    return userRoles != null && userRoles.includes(ROLE_CANNOT_EDIT_APPOINTMENTS);
  },
  checkCannotDeleteAppointments: (userRoles) => {
    return userRoles != null && userRoles.includes(ROLE_CANNOT_DELETE_APPOINTMENTS);
  },
  checkCanEditPriceOnAppointmentCreation: (userRoles) => {
    if (userRoles != null && userRoles.includes(ROLE_CANNOT_EDIT_APPOINTMENTS)) {
      return userRoles.includes(ROLE_CAN_EDIT_PRICE_ON_APPOINTMENT_CREATION);
    }
    return true;
  },
  checkCannotCreateServiceOnAppointment: (userRoles) => {
    return userRoles != null && userRoles.includes(ROLE_CANNOT_CREATE_SERVICE_ON_APPOINTMENT);
  },
  checkCanDisplayAppointmentHistory(userRoles) {
    return (
      userRoles != null && ROLES_MANAGEMENT_BASIC_OR_CUSTOMER_MENU.some((val) => userRoles.includes(val))
    );
  },

  checkCanDisplayMenuCustomers(userRoles) {
    return userRoles != null && userRoles.includes(ROLE_MENU_CUSTOMERS);
  },
};

export default AuthService;
